import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import './ConfirmDialog.scss';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  children: React.ReactNode;
  cancelLabel?: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  destructive?: boolean;
}

function ConfirmDialog({
  open,
  title,
  children,
  cancelLabel = 'Cancel',
  confirmLabel,
  onCancel,
  onConfirm,
  destructive = false,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{ sx: { borderRadius: '10px' } }}
    >
      <DialogTitle className='confirm-dialog-title'>{title}</DialogTitle>
      <DialogContent className='confirm-dialog-content'>{children}</DialogContent>
      <DialogActions className='confirm-dialog-actions'>
        <Button
          className='confirm-dialog-cancel'
          variant='outlined'
          onClick={onCancel}
        >
          {cancelLabel}
        </Button>
        <Button
          className={`confirm-dialog-confirm${destructive ? ' destructive' : ''}`}
          variant='contained'
          onClick={onConfirm}
          autoFocus
          disableElevation
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.displayName = 'ConfirmDialog';
export default ConfirmDialog;
